import { Typography } from '@mui/material';
import React from 'react';
import { Dialog } from '../others/Dialog';
import { ActionButtons } from '../others/ActionButtons';

export const DialogConfirmAction = ({
    openDialogConfirm,
    setOpenDialogConfirm,
    titleDialog,
    textConfirmAction,
    textButtonConfirm,
    textButtonCancel,
    handleConfirmAction,
    openLoadingOverlay
}) => {

    return (
        <Dialog
            openDialog={openDialogConfirm}
            widthDialog="xs"
            title={titleDialog &&
                <Typography
                    sx={{ fontWeight: 'bold', fontSize: 17 }}
                >
                    {titleDialog}
                </Typography>
            }
            styleTitle={titleDialog && { px: 3, pt: 3 }}
            content={
                <Typography
                    component="div"
                    sx={{ fontSize: 16 }}
                >
                    {textConfirmAction}
                </Typography>
            }
            styleContent={{}}
            actions={
                <ActionButtons
                    onSubmit={handleConfirmAction}
                    onCancel={() => setOpenDialogConfirm(false)}
                />
            }
            openLoadingOverlay={openLoadingOverlay}
        />
    )
}
